/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LatitudeLongitude } from './LatitudeLongitude';
import {
    LatitudeLongitudeFromJSON,
    LatitudeLongitudeFromJSONTyped,
    LatitudeLongitudeToJSON,
    LatitudeLongitudeToJSONTyped,
} from './LatitudeLongitude';
import type { Hours } from './Hours';
import {
    HoursFromJSON,
    HoursFromJSONTyped,
    HoursToJSON,
    HoursToJSONTyped,
} from './Hours';
import type { PreQuoteAddress } from './PreQuoteAddress';
import {
    PreQuoteAddressFromJSON,
    PreQuoteAddressFromJSONTyped,
    PreQuoteAddressToJSON,
    PreQuoteAddressToJSONTyped,
} from './PreQuoteAddress';
import type { LocationType } from './LocationType';
import {
    LocationTypeFromJSON,
    LocationTypeFromJSONTyped,
    LocationTypeToJSON,
    LocationTypeToJSONTyped,
} from './LocationType';

/**
 * 
 * @export
 * @interface PreQuoteLocation
 */
export interface PreQuoteLocation {
    /**
     * 
     * @type {LocationType}
     * @memberof PreQuoteLocation
     */
    locationType: LocationType;
    /**
     * 
     * @type {string}
     * @memberof PreQuoteLocation
     */
    distributionWarehouseBrand?: string;
    /**
     * 
     * @type {string}
     * @memberof PreQuoteLocation
     */
    businessName?: string;
    /**
     * 
     * @type {PreQuoteAddress}
     * @memberof PreQuoteLocation
     */
    address: PreQuoteAddress;
    /**
     * 
     * @type {Hours}
     * @memberof PreQuoteLocation
     */
    hours: Hours;
    /**
     * 
     * @type {LatitudeLongitude}
     * @memberof PreQuoteLocation
     */
    latitudeLongitude: LatitudeLongitude;
    /**
     * 
     * @type {Array<string>}
     * @memberof PreQuoteLocation
     */
    accessorials: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PreQuoteLocation
     */
    notes: string;
}



/**
 * Check if a given object implements the PreQuoteLocation interface.
 */
export function instanceOfPreQuoteLocation(value: object): value is PreQuoteLocation {
    if (!('locationType' in value) || value['locationType'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('hours' in value) || value['hours'] === undefined) return false;
    if (!('latitudeLongitude' in value) || value['latitudeLongitude'] === undefined) return false;
    if (!('accessorials' in value) || value['accessorials'] === undefined) return false;
    if (!('notes' in value) || value['notes'] === undefined) return false;
    return true;
}

export function PreQuoteLocationFromJSON(json: any): PreQuoteLocation {
    return PreQuoteLocationFromJSONTyped(json, false);
}

export function PreQuoteLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreQuoteLocation {
    if (json == null) {
        return json;
    }
    return {
        
        'locationType': LocationTypeFromJSON(json['locationType']),
        'distributionWarehouseBrand': json['distributionWarehouseBrand'] == null ? undefined : json['distributionWarehouseBrand'],
        'businessName': json['businessName'] == null ? undefined : json['businessName'],
        'address': PreQuoteAddressFromJSON(json['address']),
        'hours': HoursFromJSON(json['hours']),
        'latitudeLongitude': LatitudeLongitudeFromJSON(json['latitudeLongitude']),
        'accessorials': json['accessorials'],
        'notes': json['notes'],
    };
}

  export function PreQuoteLocationToJSON(json: any): PreQuoteLocation {
      return PreQuoteLocationToJSONTyped(json, false);
  }

  export function PreQuoteLocationToJSONTyped(value?: PreQuoteLocation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationType': LocationTypeToJSON(value['locationType']),
        'distributionWarehouseBrand': value['distributionWarehouseBrand'],
        'businessName': value['businessName'],
        'address': PreQuoteAddressToJSON(value['address']),
        'hours': HoursToJSON(value['hours']),
        'latitudeLongitude': LatitudeLongitudeToJSON(value['latitudeLongitude']),
        'accessorials': value['accessorials'],
        'notes': value['notes'],
    };
}

